<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
            
          <div class="col-sm-12">
             <ValidationProvider
               name="Sale Date"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="brand">
                Sale Date <span class="required-color">*</span></label
              >
              <input
                type="date"
                id="brand"
                class="form-control"
                v-model="saleDate"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid date"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Sale Date"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-12">
                <ValidationProvider name="customer" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Customer Name</label>
                  <select
                    class="form-control"
                    v-model="customer"
                    name="customer_id"
                    style="width: 100%;"
                  >
                    <option id="customer" selected value=""
                      >Choose Customer</option
                    >
                    <option
                      v-for="item in customerList"
                      :key="item.customer_id"
                      v-bind:value="item.customer_id"
                      >{{ item.customer_name }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
          <div class="col-sm-6">
             <ValidationProvider
               name="Invoice No"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="bill-no">
                Invoice Number <span class="required-color">*</span></label
              >
              <input
                type="text"
                class="form-control"
                id="bill-no"
                v-model="invoiceNumber"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid invoice number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Invoice Number"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
          <div class="col-sm-6">
             <ValidationProvider
               name="Invoice Amount"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="amount">
                Invoice Amount <span class="required-color">*</span></label
              >
              <input
                type="text"
                id="amount"
                class="form-control"
                v-model="invoiceAmount"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid invoice amount"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Invoice Amount"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>

          <div class="col-md-12">
      <table class="table">
        <thead>
          <tr>
            <th colspan="3">Product</th>
            <th colspan="1" class="qty-cell">Quantity</th>
            <th colspan="2">Unit Price</th>
            <th colspan="2">Sub Total</th>
            <th colspan="1" class="icon-wrap"></th>
          </tr>
        </thead>
        <tbody>
          <product-line
            v-for="(product, k) in cartItems"
            :key="k"
            :index="k"
            :productList="productList"
            :product="product"
            @update-total="updateTotal"
            @remove-row="removeRow"
          />
          <tr>
            <td colspan="4"><a href="#" @click="addNewRow()">Add Product</a></td>
          </tr>
          <tr>
            <th colspan="6" class="text-right align-center">Total</th>
            <td>
              <div class="input-group">
                <span class="input-group-addon" id="basic-addon1"><i class="fa fa-rupee"></i></span>
                <input class="ml-2 form-control" v-model="cartTotal" readonly>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
          </div>
          <div class="modal-footer" style="text-align: right">
           <div class="col-sm-12">
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";
import ProductLine from './ProductLine.vue'

export default {
  props: ["saleId"],
  name: "AddSale",
  data() {
    return {
      response: null,
      saveCat: false,
      itemId: '',
      saleDate: '',
      invoiceNumber: '',
      invoiceAmount: '',
      customer: '',
      customerList: [],
      productList: [],
      productMaster: [],
      cartItems: [],
      errors : [],
      loading: false,
    };
  },
  components: {
    ProductLine
  },
  computed: {
    cartTotal: function () {
      var total = this.cartItems.reduce((acc, item) => acc + item.sub_total, 0)
      return total
    },
    cartProducts: function () {
      var productList = this.cartItems.filter(function (obj) {
        return obj.product_id !== ''
      })
      return productList
    }
  },
  methods: {
    updateTotal: function ($event) {
      this.cartItems[$event.key].product_id = $event.product_id
      this.cartItems[$event.key].quantity = $event.quantity
      this.cartItems[$event.key].price = $event.price
      this.cartItems[$event.key].sub_total = $event.sub_total
      this.cartItems[$event.key].product_name = $event.product_name
      // this.productsTotal += $event.sub_total
      this.productList = this.productList.filter(function (obj) {
        return obj.product_id !== $event.product_id
      })
    },
    removeRow: function ($event) {
      this.cartItems = this.cartItems.filter(function (obj) {
        return obj.product_id !== $event.product_id
      })
      this.productList.push($event)
    },
    addNewRow: function () {
      this.cartItems.push({
        product_id: '',
        quantity: '',
        price: '',
        sub_total: 0,
        product_name: ''
      })
    },
    getCustomers: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_customers", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.customerList = response.data.values;
          } else {
            this.customerList = data.customerList;
          }
        });
    },
    getCartList: function(id) {
      const list = {
        filter: {
          sale_id: id
        },
      };
      api
        .request("post", "GeneralApis/get_sale_items", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          var cartList = [];
          if (data.errorcode) {
            this.cartItems = response.data.values;
          } else {
            cartList = data.cartList;
          }
          cartList.forEach(item => {
            this.cartItems.push({
              product_id: item.product_id,
              quantity: item.quantity,
              price: item.unit_price,
              sub_total: parseInt(item.quantity) * parseInt(item.unit_price),
              product_name: item.product_name
            })
          });
        });
    },
    getProducts: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            this.productList = response.data.values;
          } else {
            this.productList = data.productList;
            this.productMaster = this.productList
          }
        });
    },
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.saleId;
      this.errors = []
      if (!this.saleDate) {
        this.errors.push("Sale Date is required.");
      }
      if (!this.invoiceAmount) {
        this.errors.push("Invoice Amount is required.");
      }
      if (!this.customer) {
        this.errors.push("Customer is required.");
      }
      if(!this.errors.length){
      const addItem = {
        "sale-form": {
          sale_id: this.itemId,
          sale_date: this.saleDate,
          invoice_number: this.invoiceNumber,
          invoice_amount: this.invoiceAmount,
          customer_id: this.customer,
          product_list: this.cartProducts
        },
      };
      if (this.itemId > 0) {
        console.log('add_item', addItem)
        api
          .request("post", "GeneralApis/edit_sale", addItem)
          .then((response) => {
            console.log(response)
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        console.log('add_item', addItem)
        api
          .request("post", "GeneralApis/add_sale", addItem)
          .then((response) => {
            var data = response.data;
            console.log('')
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getSale: function() {
      var sale_id = this.$props.saleId;
        (this.saleDate = ""),
        (this.invoiceAmount = ""),
        (this.invoiceNumber = ""),
        (this.itemId = 0);
      if (sale_id > 0) {
        this.itemId = sale_id;

        const getItem = {
          filter: {
            sale_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_sales", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const saleList = data.saleList[0];
              this.saleDate = saleList.sale_date;
              this.invoiceNumber = saleList.invoice_number;
              this.invoiceAmount = saleList.invoice_amount;
              this.customer = saleList.customer_id
            }
          });
      }
    },
  },
  mounted() {
    this.getSale();
    this.getCustomers();
    this.getProducts();
    if (this.$props.saleId) {
      this.getCartList(this.$props.saleId)
    }
  },
};
</script>

<style scoped>
.qty-cell{
  width: 50px;
}
</style>